/** for an object, halves all numerical values within  */
export function halveAllObjectValues(obj, divisionFactor = 2) {
  const result = {};
  for (const key in obj) {
    if (typeof obj[key] === "object") {
      // If the value is an object, recursively halve its values
      result[key] = halveAllObjectValues(obj[key], divisionFactor);
    } else {
      if (typeof obj[key] === "number") {
        //Round if it was an integer
        result[key] = Number.isInteger(obj[key])
          ? Math.round(obj[key] / divisionFactor)
          : obj[key] / divisionFactor;
      } else {
        result[key] = obj[key];
      }
    }
  }
  return result;
}
